import builder from '../builder';
import InterfaceArrowsRight from '../../streamline-icons/bold/interface-arrows-right.svg';

export default builder('IconInterfaceArrowsRightBold', InterfaceArrowsRight);
